import React from "react";

const wrapStyle = {
  maxWidth: "860px",
  margin: "0 auto",
  padding: "48px 20px 88px",
  lineHeight: 1.8,
  color: "#111",
};

const titleStyle = {
  fontSize: "clamp(28px, 4vw, 36px)",
  fontWeight: 700,
  letterSpacing: "0.02em",
  margin: "0 0 20px",
};

const leadStyle = {
  margin: "6px 0 28px",
  fontSize: "clamp(14px, 2vw, 16px)",
  color: "#555",
};

const sectionStyle = {
  borderTop: "1px solid rgba(0,0,0,0.08)",
  padding: "22px 0",
};

const dlStyle = {
  display: "grid",
  gridTemplateColumns: "180px 1fr",
  gap: "10px 18px",
};

export function Section({ children }) {
  return <section style={sectionStyle}>{children}</section>;
}

export function Dl({ children }) {
  return <dl style={dlStyle}>{children}</dl>;
}

export default function LegalLayout({ title, description, children }) {
  return (
    <main style={wrapStyle}>
      <h1 style={titleStyle}>{title}</h1>
      {description ? <p style={leadStyle}>{description}</p> : null}
      {children}
      <nav style={{ marginTop: 36, fontSize: 14 }}>
        <a href="/terms">利用規約</a>{" / "}
        <a href="/tokushoho">特定商取引法に基づく表記</a>{" / "}
        <a href="/privacy-policy">プライバシーポリシー</a>
      </nav>
    </main>
  );
}